import React from "react";
import { useAIPrompt } from "../context/AIPromptContext";
import AIPromptView from "./AIPromptView";

function Layout({ children, classmain = "page" }) {
  const { isPromptMode } = useAIPrompt();

  if (isPromptMode) {
    return <AIPromptView />;
  }

  return (
    <div className="relative">
      {/* Corner decorations */}
      <div className="corner corner-top-left"></div>
      <div className="corner corner-top-right"></div>
      <div className="corner corner-bottom-left"></div>
      <div className="corner corner-bottom-right"></div>
      
      {/* Dot pattern background */}
      <div
          className="absolute inset-0 pointer-events-none z-0"
          style={{
              backgroundImage: 'radial-gradient(circle, #e2e8f0 1.5px, transparent 1.5px)',
              backgroundSize: '24px 24px'
          }}
      ></div>
      
      <main className={`relative ${classmain}`}>{children}</main>
    </div>
  );
}

export default Layout;
